export default __webpack_public_path__ + "static/wave_circle_faq_2-f8f5379adbb6e40098cdc6cd50df80b7.svg";